// extracted by mini-css-extract-plugin
module.exports = {"region":"region--XwUr-","region__icon":"region__icon--1UBqB","region__text":"region__text--3zPSM","region__select":"region__select--3aB1c"};